// -------------------------------------------------------------------------------------------
// The goal of this file is to allow asynchronous importing of DevExpress components.
// If you import all classes directly in your components, DevExpress will be included in your bundle.
// But DevExpress components are huge (~600KB gzipped), so we want to load them asynchronously.
// -------------------------------------------------------------------------------------------
// HOW TO USE:
// 1. import DevExpress components ONLY from this file (never from 'devextreme' directly)
// 2. For components use `<DXS.component_name />` (e.g. `<DXS.Button />`), for instantiation use use `new DXS.class_name()`

import type { Cancelable } from 'devextreme/events';
import type {
  AppointmentDragging,
  ISchedulerOptions,
  Resource,
  Scheduler,
  View,
  SchedulerRef,
} from 'devextreme-react/scheduler';
import type {
  AppointmentClickEvent,
  AppointmentDblClickEvent,
  AppointmentFormOpeningEvent,
  AppointmentRenderedEvent,
  AppointmentUpdatingEvent,
  ViewType,
  Appointment,
} from 'devextreme/ui/scheduler';
import { useDataSource } from '../dx-data-source';
export type {
  AppointmentClickEvent,
  AppointmentDblClickEvent,
  AppointmentFormOpeningEvent,
  AppointmentRenderedEvent,
  AppointmentUpdatingEvent,
  ViewType,
  AppointmentDragging,
  ISchedulerOptions,
  Resource,
  SchedulerRef,
  View,
  Appointment,
  Cancelable,
};

let _promise: Promise<any> | null;
let _isLoaded: boolean;
let _error: any;

export let DXS: {
  Scheduler: typeof Scheduler;
  View: typeof View;
  Resource: typeof Resource;
  AppointmentDragging: typeof AppointmentDragging;
} = {} as any;
export function useDxScheduler() {
  useDataSource();
  if (!_isLoaded) {
    if (!_promise) {
      _promise = initScheduler();
    }
    // will trigger Suspense
    throw _promise;
  }
  if (_error) {
    throw _error;
  }
}

function initScheduler() {
  return Promise.all([
    import('devextreme-react/scheduler').then((x) => {
      DXS = { ...DXS, ...x };
    }),
    import('devextreme/ui/scheduler').then((x) => {
      DXS = { ...DXS, ...x };
    }),
  ])
    .finally(() => (_isLoaded = true))
    .catch((e) => (_error = e));
}
